define('lib/transforms/series.mapByCode',['../page-cache', '../format-markdown'], function (PageCache, formatMarkdown) {
  /*
  Replacement for window.bat.SERIES_LIST
  Waits for the original series data to be set in the session
  transforms that series.raw data into a map, accessible via seriesCode

  Handles some data cleanup as well (prius __v__, prius __c__) while adding some HTML to series_display_name
  since we now have HTML in some series_display_name's, we tack on series_name as well
  */

  PageCache.await('series.raw').then(function (data) {
    var allSeries = data.seriesDepthOne.series;
    var seriesMap = [];

    allSeries.forEach(function (item) {
      var found = seriesMap[item.series_code];

      // if existing series has a larger year, use that
      if (found && found.year > item.year) {
        found.year = found.year;
      } else {
        seriesMap[item.series_code] = {
          series_name: item.series_name,
          series_display_name: formatMarkdown(item.series_display_name),
          year: item.year
        };
      }
    });

    PageCache.set('series.map', seriesMap);
    return seriesMap;
  });
});

